import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

function Notice({ children, type = 'error', ...props }) {
  return (
    <div className={classnames('notice spacing', `notice-type-${type}`)} {...props}>
      {children}
    </div>
  )
}

Notice.propTypes = {
  type: PropTypes.oneOf(['error', 'success']),
}

export default Notice
